// @flow

import { dispatch, getState } from 'redux/store'
import { mergeMap } from 'redux/action'

export function setFixedHeight (height: { top?: number, bottom?: number }) {
  dispatch(mergeMap('fixedHeight', height))
}

let oldHeights
export function getFixedHeight (): { top: number, bottom: number } {
  let newHeights = {
    top: getState().map.getIn(['fixedHeight', 'top'], 0),
    bottom: getState().map.getIn(['fixedHeight', 'bottom'], 0)
  }
  if (
    oldHeights &&
    oldHeights.top === newHeights.top &&
    oldHeights.bottom === newHeights.bottom
  ) {
    return oldHeights
  }
  oldHeights = newHeights
  return oldHeights
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/redux/fixedHeight.js